import shaka from "shaka-player/dist/shaka-player.ui.js";
import {TypePlayList} from "../constant";

const TextRunPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    content: String,
    _styleWrapper: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.content}</p>
    </div>
  },
  mounted() {
    this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
  },
}

const RSSPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    item: Object,
    _styleWrapper: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.content}</p>
    </div>
  },
  data() {
    return {
      content: '',
      interval: '',
    }
  },
  mounted() {
    let that = this;
    this.loadDataRss();
    this.interval = setInterval(() => {
      that.content = '';
      that.loadDataRss();
    }, 30000)
  },
  methods: {
    loadDataRss() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/screen-file/getRss",
        dataSubmit: function () {
          return {
            url: that.item.url
          };
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            for (var i = 0; i < 10; i++) {
              var content = response.data.data[i].title + " : " + response.data.data[i].description.replace(/<[^>]*>?/gm, '')
                .replace(/\u00a0/g, " ").replace(/\s/g, " ").replace(/\xA0/g, " ").replace(/&#160;/g, ' ') + " ";
              that.content += content;
            }
            that.$sendMessageSaveHistory(0, that.fileId, that.$store.state.messageSocket.id, null, that.$helper.formatDate(that.$store.state.messageSocket.startTime), that.idLayer);
          }
        },
        errorCallback: function (error) {
          that.$sendMessageSaveHistory(2, that.fileId, that.$store.state.messageSocket.id, null, that.$helper.formatDate(that.$store.state.messageSocket.startTime), that.idLayer);
          // that.$helper.handleError(that.$router, error);
        },
      });
    },
    marquee(args) {
      // var that = $('p');
      // var textWidth = this.textWidth(),
      //   offset = that.width().toFixed(0),
      //   width = offset,
      //   css = {
      //     'text-indent': that.css('text-indent'),
      //     'overflow': that.css('overflow'),
      //     'white-space': that.css('white-space')
      //   },
      //   marqueeCss = {
      //     'text-indent': width,
      //     'overflow': 'hidden',
      //     'white-space': 'nowrap'
      //   },
      //   args = $.extend(true, {count: -1, speed: 0, leftToRight: false}, args),
      //   i = 0,
      //   stop = textWidth * -1,
      //   dfd = $.Deferred();
      //
      // function go() {
      //   if (that.css('overflow') != "hidden") {
      //     that.css('text-indent', width + 'px');
      //     return false;
      //   }
      //   if (!that.length) return dfd.reject();
      //   // if (width == stop) {
      //   //   i++;
      //   //   if (i == args.count) {
      //   //     that.css(css);
      //   //     return dfd.resolve();
      //   //   }
      //   //   if (args.leftToRight) {
      //   //     width = textWidth * -1;
      //   //   } else {
      //   //     width = offset;
      //   //   }
      //   // }
      //   that.css('text-indent', width + 'px');
      //   if (args.leftToRight) {
      //     width++;
      //   } else {
      //     width--;
      //   }
      //   setTimeout(go, args.speed);
      // }
      //
      // if (args.leftToRight) {
      //   width = textWidth * -1;
      //   width++;
      //   stop = offset;
      // } else {
      //   width--;
      // }
      // that.css(marqueeCss);
      // go();
      // return dfd.promise();
    },
    textWidth() {
      var calc = `<span style="display:none">${this.content}</span>`;
      $('body').append(calc);
      var width = $('body').find('span:last').width();
      $('body').find('span:last').remove();
      return width;
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
}

const TextNormalPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    content: String,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <div style={this._style}>{this.content}</div>
  },
  mounted() {
    this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
  },
}

const ImageSinglePlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    url: String,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <img src={this.url} alt={this.url} style={this._style}/>
  },
  mounted() {
    this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
  },
}

const VideoSinglePlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    manifestUrl: {
      type: String,
      required: true
    },
    posterUrl: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    },
    muted: Boolean,
  },
  render() {
    return <div ref="videoContainer" style={this._style}>
      <video ref="videoPlayer" poster={this.posterUrl}
             style="width:100%;height:100%;object-fit:cover;" loop muted={this.muted}></video>
    </div>
  },
  mounted() {
    if (shaka.Player.isBrowserSupported()) {
      const player = new shaka.Player(this.$refs.videoPlayer);
      const ui = new shaka.ui.Overlay(
        player,
        this.$refs.videoContainer,
        this.$refs.videoPlayer
      );
      ui.getControls().setEnabledNativeControls(false);
      const config = {
        addSeekBar: false,
        controlPanelElements: ["overflow_menu"],
        // overflowMenuButtons: ['cast'],
      };
      ui.configure(config);

      // player.configure({
      // drm: {
      //   servers: { 'com.widevine.alpha': this.licenseServer }
      // }
      // });

      player
        .load(this.manifestUrl)
        .then(() => {
          this.$refs.videoPlayer.play();
          this.saveHistory(0);
        }).catch(this.onError); // onError is executed if the asynchronous load fails.

    }
  },
  methods: {
    onError(error) {
      this.saveHistory(2);
    },
    saveHistory(status) {
      this.$sendMessageSaveHistory(status, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
    }
  }
}

const YoutubePlayer = {
  props: {
    idLayer: String,
    videoId: String,
    url: String,
    width: Number,
    height: Number,
    isMuted: Boolean,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    // return <iframe src={this.url} allowFullScreen allow="autoplay" width={this.width}
    //                frameBorder="0" height={this.height}></iframe>
    return <div id="player"></div>
  },
  data() {
    return {
      player: null
    }
  },
  created() {
  },
  mounted() {
    this.onYouTubeIframeAPIReady();
  },
  methods: {
    onYouTubeIframeAPIReady() {
      this.player = new YT.Player('player', {
        height: this.height,
        width: this.width,
        videoId: this.videoId,
        playerVars: {
          'autoplay': 1,
          // 'playsinline': 1,
          'rel': 0,
          'showinfo': 0,
          'playlist': this.videoId,
          'loop': 1,
          'mute': this.isMuted === true ? 1 : 0,
          'modestbranding': 1,
          'controls': 0,
          'disablekb': 1
        },
        events: {
          'onReady': this.onPlayerReady,
          'onStateChange': this.onPlayerStateChange,
          'onError': this.onPlayerError
        }
      });
    },
    onPlayerReady(event) {
      event.target.playVideo();
    },
    onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING) {
        this.$sendMessageSaveHistory(0, null, this.$store.state.messageSocket.id, this.videoId, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
      }
    },
    onPlayerError(event) {
      this.$sendMessageSaveHistory(2, null, this.$store.state.messageSocket.id, this.videoId, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
    }
  },
}

const DocumentPlayer = {
  props: {
    fileId: Number,
    idLayer: String,
    item: Object,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <img src={this.itemsImage[this.index]} alt={this.itemsImage[this.index]} style={this._style}/>
  },
  data() {
    return {
      urlImage: '',
      itemsImage: [],
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.generateImageDocument();
    this.saveHistory();
  },
  methods: {
    generateImageDocument() {
      var documentConvert = this.item.urlDocumentConvert;
      if (documentConvert) {
        if (documentConvert.includes(",")) {
          this.itemsImage = documentConvert.split(",");
        } else {
          this.itemsImage.push(documentConvert);
        }
      }
      this.nextImage();
    },
    nextImage() {
      let that = this;
      var duration = that.item.duration.split(':'); // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.itemsImage.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
      }, seconds)
    },
    saveHistory() {
      this.$sendMessageSaveHistory(0, this.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
    }
  },
  watch: {
    index() {
      this.nextImage();
    }
  }
}

const VideoPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ""
    },
    muted: Boolean,
  },
  render() {
    return <div ref="videoContainer" style={this._style}>
      <video ref="videoPlayer" poster={this.posterUrl}
             style="width:100%;height:100%;object-fit:cover;" muted={this.muted}></video>
    </div>
  },
  data() {
    return {
      indexVideo: 0,
      posterUrl: '',
      lengthHistory: 0
    }
  },
  mounted() {
    if (shaka.Player.isBrowserSupported()) {
      const player = new shaka.Player(this.$refs.videoPlayer);
      const ui = new shaka.ui.Overlay(
        player,
        this.$refs.videoContainer,
        this.$refs.videoPlayer
      );
      ui.getControls().setEnabledNativeControls(false);
      const config = {
        addSeekBar: false,
        controlPanelElements: ["overflow_menu"],
        // overflowMenuButtons: ['cast'],
      };
      ui.configure(config);

      // player.configure({
      // drm: {
      //   servers: { 'com.widevine.alpha': this.licenseServer }
      // }
      // });

      let that = this;
      player.load(this.items[this.indexVideo].url).then(() => {
        that.$refs.videoPlayer.play();
        that.saveHistory(0);
      }).catch(this.onError);

      this.$refs.videoPlayer.addEventListener("ended", () => {
        if (this.indexVideo < this.items.length - 1) {
          this.indexVideo += 1;
        } else {
          this.indexVideo = 0;
        }
        this.posterUrl = this.items[this.indexVideo].urlThumbnail != null ? this.items[this.indexVideo].urlThumbnail : '';
        player.load(this.items[this.indexVideo].url)
          .then(() => {
            this.$refs.videoPlayer.play();
            this.saveHistory(0);
          }).catch(this.onError);
      })
    }
  },
  methods: {
    onError(error) {
      this.saveHistory(2);
    },
    saveHistory(status) {
      if (this.lengthHistory < this.items.length) {
        let item = this.items[this.indexVideo];
        this.$sendMessageSaveHistory(status, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        this.lengthHistory += 1;
      }
    }
  }
}

const ImagePlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <img src={this.items[this.index].url} alt={this.items[this.index].url} style={this._style}/>
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.nextImage();
    this.saveHistory();
  },
  methods: {
    nextImage() {
      let that = this;
      var duration = that.items[that.index].duration.split(':'); // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
        this.saveHistory();
      }, seconds)
    },
    saveHistory() {
      if (this.lengthHistory < this.items.length) {
        let item = this.items[this.index];
        this.$sendMessageSaveHistory(0, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        this.lengthHistory += 1;
      }
    }
  },
  watch: {
    index() {
      this.nextImage();
    }
  }
}

const DocumentPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return this.htmlContent;
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0,
      dataImages: [],
      htmlContent: ''
    }
  },
  mounted() {
    this.generateDataImages();
    this.next();
  },
  methods: {
    generateDataImages() {
      this.items.map(each => {
        this.$sendMessageSaveHistory(0, each.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        each.urlImagesDoc.map(img => {
          this.dataImages.push({
            duration: each.duration,
            src: img
          });
        });
      });
      this.htmlContent =
        <img src={this.dataImages[this.index].src} alt={this.dataImages[this.index].src} style={this._style}/>;
    },
    next() {
      let that = this;
      var duration = that.dataImages[that.index].duration.split(':'); // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.dataImages.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
      }, seconds)
    },
  },
  watch: {
    index() {
      this.next();
    }
  }
}
const TextNormalPlayListPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <div style={this._style} ref="textNormalContent">{this.items[this.index].content}</div>
  },
  data() {
    return {
      index: 0,
      lengthHistory: 0
    }
  },
  mounted() {
    this.nextContent();
    this.saveHistory();
  },
  methods: {
    nextContent() {
      let that = this;
      var duration = that.items[that.index].duration.split(':');
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
        that.saveHistory();
      }, seconds)
    },
    saveHistory() {
      if (this.lengthHistory < this.items.length) {
        let item = this.items[this.index];
        this.$sendMessageSaveHistory(0, item.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        this.lengthHistory += 1;
      }
    }
  },
  watch: {
    index() {
      this.nextContent();
    }
  }
}
const TextRunPlayListPlayer = {
  props: {
    items: Object,
    idLayer: String,
    _styleWrapper: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    }
  },
  render() {
    return <div class="scroll-left" style={this._styleWrapper}>
      <p class="marquee" style={this._style}>{this.getContent}</p>
    </div>
  },
  computed: {
    getContent() {
      var _content = '';
      this.items.playListDetailModels.map(each => {
        if (each.content) {
          _content = _content.concat(each.content + " ");
        }
      });
      return _content;
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.items.playListDetailModels.map(each => {
      this.$sendMessageSaveHistory(0, each.fileId, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
    })
  },
  methods: {},
  watch: {}
}

const CentralPlayer = {
  props: {
    idLayer: String,
    items: Array,
    _styleWrapper: {
      type: String,
      required: false,
      default: ""
    },
    _style: {
      type: String,
      required: false,
      default: ""
    },
    muted: Boolean,
  },
  render() {
    return this.htmlContent;
  },
  data() {
    return {
      index: 0,
      posterUrl: '',
      lengthHistory: 0,
      player: null,
      ui: null,
      htmlContent: ''
    }
  },
  mounted() {
    this.generateLayer();
  },
  methods: {
    generateLayer() {
      let that = this;
      if (this.items[this.index].typeFile == 0) {
        if (this.items[this.index].isRun === true) {
          this.htmlContent = <div class="scroll-left" style={this._styleWrapper}>
            <p class="marquee" style={this._style}>{this.items[this.index].content}</p>
          </div>
        } else {
          this.htmlContent = <div style={this._styleWrapper}>{this.items[this.index].content}</div>
          this.nextLayer();
        }
        this.player = null;
      } else if (this.items[this.index].typeFile == 1) {     /* File hình ảnh */
        this.htmlContent =
          <img src={this.items[this.index].url} alt="" style={this._style}/>
        this.nextLayer();
        this.player = null;
      } else if (this.items[this.index].typeFile == 2) {   /* File Video */
        this.htmlContent =
          <div ref="videoContainer" style={this._style}>
            <video ref="videoPlayer" poster={this.posterUrl}
                   style="width:100%;height:100%;object-fit:cover;" muted={this.muted}>
            </video>
          </div>
        this.generateVideo();
      }
      that.saveHistory(0);
    },
    async generateVideo() {
      await this.sleep(100);
      if (shaka.Player.isBrowserSupported()) {
        if (this.player == null) {
          this.player = new shaka.Player(this.$refs.videoPlayer);
          this.ui = new shaka.ui.Overlay(
            this.player,
            this.$refs.videoContainer,
            this.$refs.videoPlayer
          );
          this.ui.getControls().setEnabledNativeControls(false);
          const config = {
            addSeekBar: false,
            controlPanelElements: ["overflow_menu"],
          };
          this.ui.configure(config);

          this.player.load(this.items[this.index].url).then(() => {
            this.$refs.videoPlayer.play();
          }).catch(this.onError);

          this.$refs.videoPlayer.addEventListener("ended", (e) => {
            if (this.index < this.items.length - 1) {
              this.index += 1;
            } else {
              this.index = 0;
              if (this.items[this.index].typeFile == TypePlayList.VIDEO) {
                this.posterUrl = this.items[this.index].urlThumbnail != null ? this.items[this.index].urlThumbnail : '';
                this.player.load(this.items[this.index].url)
                  .then(() => {
                    this.$refs.videoPlayer.play();
                  }).catch(this.onError);
              }
            }
          })
        } else {
          this.player.load(this.items[this.index].url).then(() => {
            this.$refs.videoPlayer.play();
          }).catch(this.onError);
        }
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    onError(error) {
      this.saveHistory(2);
    },
    nextLayer() {
      let that = this;
      var duration = that.items[that.index].duration.split(':'); // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000;
      setTimeout(() => {
        if (that.index < that.items.length - 1) {
          that.index += 1;
        } else {
          that.index = 0;
        }
      }, seconds)
    },
    saveHistory(status) {
      if (this.lengthHistory < this.items.length) {
        let item = this.items[this.index];
        this.$sendMessageSaveHistory(status, item.id, this.$store.state.messageSocket.id, null, this.$helper.formatDate(this.$store.state.messageSocket.startTime), this.idLayer);
        this.lengthHistory += 1;
      }
    }
  },
  watch: {
    index() {
      this.generateLayer();
    },
    _style(value) {
      if (this.items[this.index].typeFile == 0) {
        this.htmlContent.elm.style = this._styleWrapper;
        this.htmlContent.elm.firstChild.style = value;
      } else {
        this.htmlContent.elm.style = value;
      }
    },
  }
}

export default {
  textRunPlayer: TextRunPlayer,
  textNormalPlayer: TextNormalPlayer,
  imageSinglePlayer: ImageSinglePlayer,
  videoSinglePlayer: VideoSinglePlayer,

  youtubePlayer: YoutubePlayer,
  rssPlayer: RSSPlayer,
  documentPlayer: DocumentPlayer,

  videoPlayListPlayer: VideoPlayListPlayer,
  documentPlayListPlayer: DocumentPlayListPlayer,
  imagePlayListPlayer: ImagePlayListPlayer,
  textNormalPlayListPlayer: TextNormalPlayListPlayer,
  textRunPlayListPlayer: TextRunPlayListPlayer,

  centralPlayer: CentralPlayer
}



// WEBPACK FOOTER //
// ./src/views/VideoPlayerComponent.js